<template>
  <div>
    <h6 class="mb-8 font-bold text-1xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachosmaquinaria')">Despacho / Venta:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{  form.id}} 
    </h6>
    <trashed-message v-if="diario.deleted_at" class="mb-6" @restore="restore">
     Venta Eliminado!
    </trashed-message>
     <h1 class="mb-8 font-bold text-1xl"> Detalle de Ingres{{i=0}} de Ventas</h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="updateventa">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <select-input v-model="form2.maquinaria_id" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/4" label="Maquinaria/Vehiculo" required>
            <option v-for="maquinaria in maquinarias" :key="maquinaria.id" :value="maquinaria.id">{{ maquinaria.id }} - {{ maquinaria.clase}} - {{maquinaria.placas}}</option>
        </select-input>

        <select-input v-model="form2.proyecto" :error="form.errors.proyecto" class="pr-6 pb-8 w-full lg:w-1/4" label="Destino de Proyecto" required>
            <option v-for="proyecto in proyectos" :key="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
        <select-input v-model="form2.operador" :error="form.errors.operador" class="pr-6 pb-8 w-full lg:w-1/4" label="Operador" required>
            <option v-for="conductor in conductores" :key="conductor.id">{{ conductor.nombres }} {{ conductor.apellidos }}</option>
        </select-input>
        <select-input v-model="form2.gasolinera" :error="form2.errors.gasolinera" class="pr-6 pb-8 w-full lg:w-1/4" label="Gasolinera" required>
          <option v-for="gasolinera in gasolineras" :key="gasolinera.id" :value="gasolinera.nombre">{{ gasolinera.nombre }}</option>
        </select-input>
        <text-input v-if="gasolineraSeleccionada && gasolineraSeleccionada.documento_editable" v-model="form2.numero_documento" :error="form2.errors.numero_documento" class="pr-6 pb-8 w-full lg:w-1/4" label="Nº Documento" required/>
        <label>Hora:</label>
          <the-mask :mask="['##:##:##']" v-model="form2.hora" class="pr-6 pb-8 w-full lg:w-1/4" placeholder="Ingrese la hora" required/>
          <text-input v-model="form2.numero_comprobante" :error="form.errors.numero_comprobante" class="pr-6 pb-8 w-full lg:w-1/5" label="Nº Comprobante" required/>
          <text-input v-model="form2.cantidad_tanqueada" :error="form.errors.cantidad_tanqueada" class="pr-6 pb-8 w-full lg:w-1/5" label="Total Galones" required/>
          <text-input v-model="form2.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/5" label="Odometro" required/>
          <text-input v-model="form2.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />
                    
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Agregar Despacho</loading-button>
        </div>
      </form>
    </div>
    <br>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="flex flex-col">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow-md sm:rounded-lg">
          <table class="min-w-full">
        <thead class="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Nº
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Nº Orden
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Operador
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Maquinaria
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                            Horometro
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Cantidad Galones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      
    <tr v-for="detalle in detalles" :key="detalle.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
         <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              {{ i=i+1}}
            </inertia-link>
          </td>
          <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              {{ detalle.numero_comprobante }}
            </inertia-link>
          </td>
          <td>
             <inertia-link class="px-6 py-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              {{ detalle.operador }}
            </inertia-link>
          </td>
          <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              {{ detalle.clase }} {{ detalle.placas }}
            </inertia-link>
          </td>
          <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              {{ detalle.odometro_actual }}
            </inertia-link>
          </td>
          <td>
             <inertia-link class="px-6 py-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              {{ detalle.cantidad_tanqueada }}
            </inertia-link>
          </td>
         
          <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
            <inertia-link class="px-4 flex items-center" :href="route('despachoventas.edit', detalle.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="detalles.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encuentran datos</td>
        </tr>
       </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
    </div>
    <br>
    <h1 class="mb-8 font-bold text-1xl"> Encabezado Ingreso </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
 
       <form @submit.prevent="update">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
       <text-input  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-2/6" label="Fecha" required/>                          
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Ingreso</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar y Pasar a los Despachos</loading-button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datetimepicker'
import {TheMask} from 'vue-the-mask'


export default {
  
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker,
    TheMask
  },
  layout: Layout,
  props: {
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,
    diario: Object,
    detalles: Array,
    gasolineras: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.diario.id,
       fecha: this.diario.fecha,
      }),
       form2: this.$inertia.form({
        maquinaria_id: null,
        despacho_diarios_id: this.diario.id,
        fecha: null,
        gasolinera: null,
        hora: null,
        proyecto: null,
        operador: null,
        numero_comprobante: null,
        numero_documento: '',
        cantidad_tanqueada: null,
        odometro_actual: null,
        observacion: null,
      }),
    }
  },
  computed: {
    gasolineraSeleccionada() {
      return this.gasolineras.find(g => g.nombre === this.form2.gasolinera)
    },
  },
  watch: {
    'form2.gasolinera'() {
      this.form2.numero_documento = this.gasolineraSeleccionada ? this.gasolineraSeleccionada.numero_documento || '' : ''
    },
  },
  methods: {
    update() {
      this.form.put(this.route('despachosmaquinaria2.update', this.diario.id))
    },
    updateventa() {
     this.form2.post(this.route('despachosdetalle.store'))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('despachosmaquinaria.destroy', this.diario.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('despachosmaquinaria.restore', this.diario.id))
      }
    },
  },
  
}
</script>
